import {IntermediatePart} from "../../parts/intermediatePart";
import {BathTubType, LayoutType} from "../../constants";
import store from "../../../../../store";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {ShowerTubCombo} from "../../parts/showerTubCombo";

export default class BathTubFixture extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "bathtub_fixture";
    this.translateId = "visualizer.bathroom.bathtub.bathtub_fixture";
    this.visible = [BathTubType.Custom60in, BathTubType.FreeStanding];
    this.partName = 'Fixture';
    this.homePageTitle = 'Bathtub Fixtures';
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    const feature = this.load_(dbFeature, new BathTubFixture());
    if (feature) {
      BathTubFixture.setAdditionalMetaData(feature);
    }
  }

  static setAdditionalMetaData(feature) {
    feature.metaData["Fixture"] = ["All"];
  }

  disabledClick() {
    const bathTubBody = this.getParent().bathTubBody;
    if (bathTubBody && bathTubBody.disabled && !this.disabled) {
      bathTubBody.disabled = false;
    }
    const bathtubParent = this.getParent();
    if (bathtubParent.layout.type === LayoutType.Small && !this.disabled) {   // switch off all shower features
      const showerBody = bathtubParent.layout.parts.Shower.showerBody;
      if (showerBody) {
        showerBody.disabled = true;
        showerBody.disabledClick();
      }
      const comboPart = bathtubParent.layout.parts[ShowerTubCombo.id];
      if (comboPart) {
        comboPart.showerTubComboIsActive = false;
      }
    }
  }

  setZIndex(zIndexes) {
    let activeSubType = "";
    switch (this.getParent().activeSubType()) {
      case BathTubType.Custom60in:
        activeSubType = "Custom60in";
        break;
      case BathTubType.FreeStanding:
        activeSubType = "FreeStanding";
        break;
    }
    let floorMount = false;
    if (zIndexes && this.activeFeature) {
      const filterGroups = store.getState().filterState.filterGroups;
      const placeTypeGroup = filterGroups.find(filterGroup => filterGroup.name === "PlaceType");
      if (placeTypeGroup) {
        const featurePlaceTypeValue = this.activeFeature.dbFeature.filterValueIDs[placeTypeGroup.id];
        if (featurePlaceTypeValue && featurePlaceTypeValue.length) {
          const currentValue = placeTypeGroup.values.find(filterValue => filterValue.id === featurePlaceTypeValue[0]);
          if (currentValue && currentValue.value === "FloorMount") {
            floorMount = true;
          }
        }
      }
      floorMount
        ? this.activeFeature.layer.zIndex = zIndexes.BathTub[activeSubType].FixtureFloorMount
        : this.activeFeature.layer.zIndex = zIndexes.BathTub[activeSubType].Fixture
    }
    if (zIndexes && this.placeholderFeature) {
      floorMount
        ? this.placeholderFeature.layer.zIndex = zIndexes.BathTub[activeSubType].FixtureFloorMount
        : this.placeholderFeature.layer.zIndex = zIndexes.BathTub[activeSubType].Fixture
    }
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    return [{
      propName: 'Fixture',
      propValue: this.getParent().getFixtureType()
    }];
  }

  setDefault(layout) {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Sahara Autumn  Porcelain Tile");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || super.setDefault(layout) || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
    }
  }

}
